// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"23b816f5","54":"23b816f5","188":"eee709ad","345":"96fb974d","580":"a3d8c80b","599":"eee709ad","843":"0cbbb371","861":"23b816f5"}[chunkId] + ".chunk.css";
};